import { Box, Grid, Link, Typography } from '@mui/material';
import React, { FC } from 'react';
import { WithdrawManualRequestSummaryDto } from 'app/interfaces/dto';
import { useStyles } from '../TransactionSummary.styles';
import { FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';
import { MoneyDto } from 'app/interfaces/dto/money.dto';
import {
  PAYPAL_INTERNATIONAL_FEE_PERCENTAGE,
  PAYPAL_WITHDRAWAL_PLATFORM_FEE_PERCENT,
} from '@okletsplay/core';

interface ComponentProps {
  summary: WithdrawManualRequestSummaryDto;
  source: MoneyDto;
  title: string;
}

export const WithdrawRequestSummary: FC<ComponentProps> = ({ summary, source, title }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.row}>
        <Typography>{title}</Typography>
      </Box>
      <Box className={classes.row}>
        <Grid container rowSpacing={1}>
          <Grid item xs={8} sm={10}>
            <Typography>Withdraw Amount</Typography>
          </Grid>
          <Grid item xs={4} sm={2} textAlign="right">
            <FormatCurrency {...source} type={FormatCurrencyType.Crypto} />
          </Grid>
          <Grid item xs={8} sm={10}>
            <Typography>Processing Fee {PAYPAL_WITHDRAWAL_PLATFORM_FEE_PERCENT}%</Typography>
          </Grid>
          <Grid item xs={4} sm={2} textAlign="right">
            <FormatCurrency {...summary.platformFee} type={FormatCurrencyType.Crypto} />
          </Grid>
          {summary.internationalFee?.currency ? (
            <>
              <Grid item xs={8} sm={10}>
                <Typography>
                  PayPal International Fee {PAYPAL_INTERNATIONAL_FEE_PERCENTAGE}%*
                </Typography>
                <Typography ml={1.5} mt={1} fontStyle="italic">
                  Currency conversion fee 4% may be applied
                </Typography>
                <Typography ml={1.5} mt={1} fontStyle="italic">
                  Additional fees may be applied based on your{' '}
                  <Link
                    href="https://www.paypal.com/webapps/mpp/paypal-fees"
                    target="_blank"
                    referrerPolicy="no-referrer"
                  >
                    PayPal account
                  </Link>
                </Typography>
              </Grid>
              <Grid item xs={4} sm={2} textAlign="right">
                <FormatCurrency {...summary.internationalFee} type={FormatCurrencyType.Crypto} />
              </Grid>
            </>
          ) : null}
          {summary.destinationAmount?.currency ? (
            <>
              <Grid item xs={8} sm={10}>
                <Typography>Forecasted Destination Amount</Typography>
              </Grid>
              <Grid item xs={4} sm={2} textAlign="right">
                <FormatCurrency {...summary.destinationAmount} type={FormatCurrencyType.Crypto} />
              </Grid>
            </>
          ) : null}
          <Grid item xs={8} sm={10}>
            <Typography>New Balance</Typography>
          </Grid>
          <Grid item xs={4} sm={2} container rowSpacing={1} justifyContent="flex-end">
            {summary.newBalances.map((balance) => (
              <Grid item sm={12} key={balance.currency + balance.amount} textAlign="right">
                <FormatCurrency {...balance} type={FormatCurrencyType.Crypto} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
